import { useEffect, useRef } from 'react';
import { useCourier } from '@trycourier/courier-react';

import { useFetchCourierInboxTokenQuery } from '../../ducks/notifications.duck';

/** Fetch a short-lived Courier inbox JWT and sign in once per token. */
export const useCourierAuth = () => {
  const { data, isLoading, isError } = useFetchCourierInboxTokenQuery();
  const courier = useCourier();
  const signedInKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!data?.token || !data?.userId) return;
    const key = `${data.userId}:${data.token}`;
    if (signedInKeyRef.current === key) return;
    signedInKeyRef.current = key;
    Promise.resolve(courier.shared.signIn({ userId: data.userId, jwt: data.token })).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.token, data?.userId]);

  return {
    isReady: !!data?.token && !isLoading && !isError,
    totalUnreadCount: courier.inbox?.totalUnreadCount ?? 0,
  };
};
